

<div class="container-fluid">
  <div class="row">
    <h2 class="heading" style="text-align:center;text-decoration: underline;">Refund & Cancellation Policy</h2>
   

    <section id="policy-block" class="privacy-policy-block">
      <div class="container-xl">
        <div class="panel-setting-main-block">
          <div class="panel-setting">
            <div class="row">
              <div class="col-md-12">

                <div class="info">
                  <p><strong>Zenithguard Refund and Cancellation Policy</strong></p>
                  <ol>
                    <li><strong> Introduction</strong></li>
                  </ol>
                  <p>At Zenithguard, we strive to ensure our customers are satisfied with our digital products, including online courses and gift voucher. We understand that sometimes you may need to request a refund or cancel a purchase. This policy outlines the conditions and processes for refunds and cancellations.</p>
                  <ol start="2">
                    <li><strong> Online Courses</strong></li>
                  </ol>
                  <p><strong>2.1. Refund Eligibility</strong></p>
                  <p>Refunds for online courses are available under the following conditions:</p>
                  <ul>
                    <li>You request a refund within 24 hours of purchase.</li>
                    <li>The product has not been downloaded, accessed, or used.</li>
                    <li>You provide a valid reason for your refund request.</li>
                  </ul>
                  <p><strong>2.2. Non-Refundable Conditions</strong></p>
                  <p>Refunds will not be provided under the following circumstances:</p>
                  <ul>
                    <li>You request a refund after 24 Hours of purchase.</li>
                    <li>The product has been downloaded, accessed, or used.</li>
                    <li>The course was purchased during a sale or with a discount coupon.</li>
                  </ul>
                  <p><strong>2.3. Refund Process</strong></p>
                  <p>To request a refund for an online course:</p>
                  <ol>
                    <li>Contact our customer support team at support@zenithguard.com.</li>
                    <li>Provide your order number, purchase date, and the reason for your refund request.</li>
                    <li>Our team will review your request and respond within 7 business days.</li>
                  </ol>
                  <p>If your refund is approved, the amount will be credited back to your original payment method within 14 business days.</p>
                  <ol start="3">
                    <li><strong> Gift Voucher</strong></li>
                  </ol>
                  <p><strong>3.1. Refund Eligibility</strong></p>
                  <p>Refunds for purchased gift voucher are available under the following conditions:</p>
                  <ul>
                    <li>You request a refund within 2 days of purchase.</li>
                    <li>The coupon has not been redeemed or used.</li>
                  </ul>
                  <p><strong>3.2. Non-Refundable Conditions</strong></p>
                  <p>Refunds will not be provided under the following circumstances:</p>
                  <ul>
                    <li>You request a refund after 2 days of purchase.</li>
                    <li>The coupon has already been redeemed or used.</li>
                  </ul>
                  <p><strong>3.3. Refund Process</strong></p>
                  <p>To request a refund for a coupon:</p>
                  <ol>
                    <li>Contact our customer support team at support@Zenithguard.com.</li>
                    <li>Provide your order number, purchase date, and the reason for your refund request.</li>
                    <li>Our team will review your request and respond within 7 business days.</li>
                  </ol>
                  <p>If your refund is approved, the amount will be credited back to your original payment method within 14 business days.</p>
                  <ol start="4">
                    <li><strong> Cancellation Policy</strong></li>
                  </ol>
                  <p><strong>4.1. Online Courses</strong></p>
                  <p>You can cancel your enrollment in an online course within 24 hours of purchase if you have not accessed of the course content. To cancel, please contact our customer support team at support@Zenithguard.com.</p>
                  <p><strong>4.2. Gift Voucher</strong></p>
                  <p>You can cancel your coupon purchase within 2 days of purchase if the coupon has not been redeemed or used. To cancel, please contact our customer support team at support@zenithguard.com.</p>
                  <ol start="5">
                    <li><strong> Contact Us</strong></li>
                  </ol>
                  <p>For any questions or concerns regarding our refund and cancellation policy, please contact us at support@zenithguard.com. We are here to assist you and ensure your satisfaction with Zenithguard products.</p>
                  <p>This policy is effective as of 1<sup>st</sup> June and is subject to change at our discretion. Please review this policy periodically for any updates.</p>
                  <p>&nbsp;</p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
